<template>
  <div class="category">
    <rightNav></rightNav>
    <lateralNavigation2></lateralNavigation2>
    <div class='banxin'>
      <div class='head'>
        <div class='all'>全部结果</div>
        <div class='arrow'></div>
        <div class='keyword'>{{classifyName}}</div>
<!--        <div class='arrow'></div>-->
      </div>
      <img class="banner" v-if="classifyBanner !== ''" :src="classifyBanner" alt="">
      <div class="content">
        <div class='sort'>
          <div>排序：</div>
          <div class='default' :class="index=='1'?'active':''" @click="defaultSort()">默认</div>
          <div class='price' :class="index=='2'?'active':''" @click="priceSort()">
              价格
              <div class='arr'>
                <div class='up' :class="type==1?'low':''"></div>
                <div class='down' :class="type==2?'high':''"></div>
              </div>
          </div>
          <div class='sales' :class="index=='3'?'active':''" @click="salesSort()">
              销量
              <img v-show="index!=='3'" src='../../../static/image/reduce@2x.png' alt='' />
              <img v-show="index=='3' && volume==1" src='../../../static/image/reduce2@2x.png' alt='' />
              <img v-show="index=='3' && volume==2" src='../../../static/image/reduce1@2x.png' alt='' />
          </div>
        </div>
        <div>
            <div v-if="total>0">
              <h3 >{{classifyName}}</h3>
              <ProductList :productList='productList'></ProductList>
            </div>
            <div v-else class="noproduct">
              <img src="../../../static/image/noorder@2x.png" alt="">
              <p class="fs20 font-color-999">该分类没有商品～</p>
            </div>
        </div>
        <el-pagination
          v-if="total>0"
          :current-page="page"
          :page-size="size"
          @current-change="handleCurrentChange"
          background layout='total, prev, pager, next' :total='total'>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import ProductList from '../../components/base/productList'
import rightNav from '../../components/canvasShow/rightNav';
import lateralNavigation2 from '../../components/base/lateralNavigation2';
export default {
  mixins: [listSearchMixin],
  components: {
    ProductList,
    rightNav,
    lateralNavigation2
  },
  data () {
    return {
      page: 1,
      size: 10,
      index: '1',
      type: '',
      volume: '',
      total: 0,
      classifyId: 0,
      classifyName: '',
      noProduct: false,
      productList: [],
      classifyBanner: ''
    }
  },
  watch: {
    $route (to, from) {
      console.log(to, from)
      let data = JSON.parse(this.$route.query.classifyData)
      this.classifyBanner = data.pic
      this.classifyName = data.cateName
      this.classifyId = data.id
      this.getClaasifyProducts()
    }
  },
  mounted () {
    var classifyData = JSON.parse(this.$route.query.classifyData)
    this.classifyBanner = classifyData.pic
    this.classifyName = classifyData.cateName
    this.classifyId = classifyData.id
    this.getClaasifyProducts()
  },
  methods: {
    // 获取分类商品
    getClaasifyProducts () {
      let self = this
      let params = {
        url: api.getClaasifyProducts,
        method: 'GET',
        payload: {
          page: this.page,
          limit: this.size,
          keyword: '',
          sid: self.classifyId,
          news: 0,
          priceOrder: this.priceOrder,
          salesOrder: this.salesOrder
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          self.productList = res.data.content
          self.total = res.data.totalElements
          if (res.data.content.length < 1) {
            self.noProduct = true
          }
        } else {
          self.$message({
              message: res.message,
              type: 'warning'
          })
        }
      })
    },
    // 分页器跳转
    handleCurrentChange (val) {
      this.page = val
      this.getClaasifyProducts()
    },
    // 默认排序
    defaultSort () {
      this.type = ''
      this.priceOrder = ''
      this.index = '1'
      this.page = 1
      this.getClaasifyProducts()
    },
    // 价格排序
    priceSort () {
      this.salesOrder = ''
      if (this.type !== 1) {
        this.type = 1
        this.priceOrder = 'asc'
      } else {
        this.type = 2
        this.priceOrder = 'desc'
      }
      this.page = 1
      this.index = '2'
      this.getClaasifyProducts()
    },
    // 销量排序
    salesSort () {
      this.priceOrder = ''
      if (this.volume !== 1) {
        this.volume = 1
        this.salesOrder = 'asc'
      } else {
        this.volume = 2
        this.salesOrder = 'desc'
      }
      this.page = 1
      this.index = '3'
      this.getClaasifyProducts()
    }
  }
}
</script>
<style lang = "scss" scoped>
.category{
    width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  padding-bottom: 143px;
  text-align: center;
  .banxin {
    width: 1252px;
    height: 100%;
    margin: 0 auto;
    margin-top: 20px;
    .head {
      width: 100%;
      height: 84px;
      line-height: 84px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .all {
        margin-right: 6px;
      }
      .keyword {
        margin: 0 6px;
        color: #D22929;
      }
      .arrow {
        background-image: url('../../../static/image/xiangyou@2x.png');
        width: 5px;
        height: 10px;
      }
    }
    .banner{
        width: 100%;
        height: 356px;
        margin-bottom: 25px;
    }
    .content{
        background-color: #FFFFFF;
        width: 100%;
        padding: 0 0px 30px;
        box-sizing: border-box;
        .sort {
          width: 100%;
          height: 63px;
          line-height: 27px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #f1f1f1;
          color: #666666;
          padding-left:50px;
        .default {
          margin-left: 20px;
          cursor: pointer;
        }
        .sales {
          cursor: pointer;
          img{
            width: 9px;
            height: 16px;
            vertical-align: middle;
          }
        }
        .price {
          display: flex;
          margin: 0 20px;
          cursor: pointer;
          .arr {
            vertical-align: middle;
            width: 12px;
            margin-left: 3px;
            .up {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-bottom-color: #999999;
            }
            .down {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-top-color: #999999;
              margin-top: 3px;
            }
          }
        }
        .active{
            color: #D22929;
            .arr{
              .high{
                border-top-color: #D22929;
              }
              .low{
                border-bottom-color: #D22929;
              }
            }
          }
       }
       h3{
           font-size: 24px;
           font-weight: bold;
           margin-bottom:10px;
           margin-top: 20px;
       }
       .noproduct{
          width: 100%;
          text-align: center;
          padding: 200px 0;
       }
      >>>.el-pagination{
        text-align: right;
        .el-pager{
          li:not(.disabled):hover{
            color: #D22929;
          }
          li:not(.disabled).active{
            background-color: #D22929;
          }
          li:not(.disabled).active:hover{
            color: #F4F4F5;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/category/index.vue